module.exports = crypto;